forestControllers.controller('adminFormsController', function($scope, $http, dialogs, $timeout, Server) {

    var dropDataReady = false;

    $scope.getLabelById = function (arr, id){

        var item = $.grep(arr, function(e){return e.id == id;});

        if(item.length > 0) {

            return item[0].label;
        }

        return "";
    };

    getDropDownData();

    $scope.add = function(which){
        if(dropDataReady){

            switch (which){
                case 'martvis_organo':
                    if($scope.add_martvis_organo){
                        $http.post('/api/dropdown-data/martvis-organo/create',
                            {"label" : $scope.add_martvis_organo}).then(getDropDownData);
                        //console.log('martvisOrganoebi', $scope.martvisOrganoebi);
                        $scope.add_martvis_organo = "";
                    }else{
                        dialogs.error('Error','მართვის ორგანო არ არის მითითებული');
                    }
                    break;
                case 'region':
                    if($scope.add_regioni && $scope.martvis_organo_for_regioni){
                        $http.post('/api/dropdown-data/region/create',
                            {'label' : $scope.add_regioni, 'martvis_organo_id' : $scope.martvis_organo_for_regioni.id})
                            .then(getDropDownData);

                        $scope.add_regioni = "";
                    }
                    break;
                case 'satyeo_ubani':
                    if($scope.add_satyeo_ubani && $scope.regioni_for_satyeo_ubani){
                        $http.post('/api/dropdown-data/satyeo_ubani/create',
                            {'label' : $scope.add_satyeo_ubani, 'regioni_id' : $scope.regioni_for_satyeo_ubani.id}).then(getDropDownData);
                    }
                    break;
                case 'satyeo':
                    if($scope.add_satyeo && $scope.satyeo_ubani_for_satyeo){
                        $http.post('/api/dropdown-data/satyeo/create',
                            {'label' : $scope.add_satyeo, 'satyeo_ubani_id' : $scope.satyeo_ubani_for_satyeo.id}).then(getDropDownData);
                    }
                    break;
                default:
                    break;
            }
        }
    }

    $scope.remove = function(which, id){
        dialogs.confirm("დასტური", "ყველა ორგანიზაცია რომელიც ექვემდებარება არჩეულ ორგანიზაციას იქნება წაშლილი. დარწმუნებული ხართ რომ გინდათ წაშალოთ?").result.then(function(){

            if(dropDataReady){

                switch (which){
                    case 'martvis_organo':

                        $http.get('/api/dropdown-data/martvis-organo/'+ id +'/delete',
                            {"label" : $scope.add_martvis_organo}).then(getDropDownData);

                        break;
                    case 'region':
                        $http.get('/api/dropdown-data/region/'+ id +'/delete',
                            $scope.userInput).then(getDropDownData);
                        break;
                    case 'satyeo_ubani':
                        $http.get('/api/dropdown-data/satyeo_ubani/'+ id +'/delete',
                            $scope.userInput).then(getDropDownData);
                        break;
                    case 'satyeo':
                        $http.get('/api/dropdown-data/satyeo/'+ id +'/delete',
                            $scope.userInput).then(getDropDownData);
                        break;
                    default:
                        break;
                }
            }
        });
    }

    function getDropDownData(){
        $http.get('/api/dropdown-data').then(function(res){
            dropDataReady = true;
            //first data is from angular responce object and second is our.
            var servData = res.data.data;
            for (var d in servData){
                //console.log(d);
                if (servData.hasOwnProperty(d)) {
                    $scope[d] = servData[d];
                }
            }
        });
        $timeout(function(){ console.log('chosen updated'); $('select').trigger("chosen:updated")}, 0);
    }

    $scope.assignedCalcTablesBySaxeoba = {};
    $scope.isRedBySaxeoba = {};

    Server.getTanrigisCxriliSaxeobas().then(function(data){

        $scope.tanrigisCxriliSaxeobas = data;

        Server.getAssociatedList().then(function(list){
            $scope.assignedCalcTablesBySaxeoba = list;
        });

        Server.getRedList().then(function(list){
            $scope.isRedBySaxeoba = list;
        });

        $timeout(function(){ console.log('chosen updated');
            $('select').trigger("chosen:updated")}, 0);
    });

    $scope.syncCalcTableAssoc = function(){

        //Update
        Server.syncChosenCalcTables({chosen : $scope.assignedCalcTablesBySaxeoba}).then(function(res){
            $scope.assignedCalcTablesBySaxeoba = res;

            dialogs.notify("განახლდა", "კალკულაციის ცხრილი წარმატებით მიენიჭა");
        }).catch(function(){
            dialogs.error("შეცდომა", "კალკულაციის ცხრილის მინიჭება ვერ მოხერხდა");
        });

        //alert(JSON.stringify($scope.assignedCalcTablesBySaxeoba));
    };

    $scope.syncIsRed = function(){

        //Update
        Server.syncIsRed({chosen : $scope.isRedBySaxeoba}).then(function(res){
            $scope.isRedBySaxeoba = res;

            dialogs.notify("განახლდა", "შითელი ნუსხა განახლდა");
        }).catch(function(){
            dialogs.error("შეცდომა", "წითელი ნუსხის განახლება ვერ მოხერხდა");
        });

        //alert(JSON.stringify($scope.assignedCalcTablesBySaxeoba));
    };

    //$scope.saxeobaFactory;

    $scope.createSaxeoba = function(){
        if($scope.saxeobaFactory){
            Server.createNewSaxeoba({'label': $scope.saxeobaFactory}).then(function(updatedSaxeobas){

                $scope.xisSaxeobas = updatedSaxeobas;

                dialogs.notify("შეიქმნა", "ხის სახეობა წარმატებით დაემატა");
            }).catch(function(){
                dialogs.error("შეცდომა", "ხის დამატება ვერ მოხერხდა");
            });
        }else{
            dialogs.error("შეცდომა", "გთხოვთ შეიყვანოთ მინიმუმ ერთი სიმბოლო");
        }
    };

    $scope.deleteSaxeoba = function(id){
        dialogs.confirm("დასტური", "დარწმულებული ხართ რომ გინდათ სახეობის წაშლა? " + id).result.then(function(){
            Server.deleteSaxeoba(id).then(function(updatedSaxeobas){
                dialogs.notify("წაიშალა", "ხის სახეობა წარმატებით წაიშალა");
                $scope.xisSaxeobas = updatedSaxeobas;
            }).catch(function(){
                dialogs.error("შეცდომა", "ხის სახეობის წაშლა ვერ მოხერხდა");
            });
        });
    };

    $scope.sbSyncMaragiTables = function(){

        var pairs = [];

        angular.forEach($scope.sbXisSaxeobas, function(el){
            if(el.sb_maragis_cxrili_saxeoba_id){
                pairs.push({saxeoba : el.id, cxrili: el.sb_maragis_cxrili_saxeoba_id});
            }

        });

        Server.sbSyncChosenMaragiTables({pairs : pairs}).then(function(res){
            alert('updated');
        }).catch(function(){
            alert('failed');
        });
    };

    $scope.sbSyncBonitetiTables = function(){

        var pairs = [];

        angular.forEach($scope.sbXisSaxeobas, function(el){
            if(el.bonitetis_cxrili_id){
                pairs.push({saxeoba : el.id, cxrili: el.bonitetis_cxrili_id});
            }

        });

        Server.sbSyncBonitetiTables({pairs : pairs}).then(function(res){
            alert('updated');
        }).catch(function(){
            alert('failed');
        });
    };

    $scope.sbSyncXnovanebaTables = function(){

        var pairs = [];

        angular.forEach($scope.sbXisSaxeobas, function(el){
            if(el.xnovaneba_cxrili_id){
                pairs.push({saxeoba : el.id, cxrili: el.xnovaneba_cxrili_id});
            }

        });

        Server.sbSyncXnovanebaTables({pairs : pairs}).then(function(res){
            alert('updated');
        }).catch(function(){
            alert('failed');
        });
    };

    Server.sbGetDrops().then(function(res){
        console.log(res);

        $scope.sbXisSaxeobas = res.sbXisSaxeobas;
        $scope.bonitetisCxrilis = res.bonitetisCxrilis;
        $scope.sbMaragisCxriliSaxeobas = res.sbMaragisCxriliSaxeobas;
        $scope.xnovanebaCxrilis = res.xnovanebaCxrilis;

    }).catch(function(){

    });
});